export default __webpack_public_path__ + "static/media/cleared.f7996fd6.svg";